import { Phone } from "lucide-react";

export default function MobileCallFab() {
  return (
    <a
      href="tel:+33185117279"
      aria-label="Appeler Big Déménagement"
      data-testid="mobile-call-fab"
      className="sm:hidden fixed bottom-5 right-5 z-40 inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#237cb5] text-white shadow-[0_18px_30px_-10px_rgba(35,124,181,0.65)] active:scale-95 transition-transform"
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full bg-[#237cb5]/60 animate-ping"
      />
      <Phone className="relative h-6 w-6" />
    </a>
  );
}
